<template>
  <Form
    v-if="show"
    class="pg-form"
    ref="formRef"
    :data-type="dataType"
    @submit.native.prevent
    :style="formProperty.style"
    :model="formData"
    :inline="formProperty.inline"
    :labelPosition="formProperty.labelPosition"
    :labelWidth="formProperty.labelWidth"
    :labelSuffix="formProperty.labelSuffix"
    :hideRequiredAsterisk="formProperty.hideRequiredAsterisk"
    :showMessage="formProperty.showMessage"
    :inlineMessage="formProperty.inlineMessage"
    :size="formProperty.size"
  >
    <template v-if="formProperty.formGroup">
      <FormGroup
        v-for="group in formItemsList"
        :key="group.code"
        :item="group"
        :inline="formProperty.inline"
      >
        <ItemRender
          v-for="item in group.children"
          :key="item.code"
          :item="item"
          :data="formData"
          :formItemWidth="formItemWidth"
          :compileSource="compileSource"
        />
      </FormGroup>
    </template>
    <template v-else>
      <ItemRender
        class="pg-form__not-form-item"
        v-for="item in formItemsList"
        :key="item.code"
        :item="item"
        :data="formData"
        :formItemWidth="formItemWidth"
        :compileSource="compileSource"
        :dragHandle="dragHandle"
        :data-type="item.code"
      />
    </template>
  </Form>
</template>
<script setup>
import { toRef, watch, ref, computed, nextTick, onMounted, onUnmounted } from 'vue'
import Sortable from 'sortablejs'
import { Form } from 'element-ui'
import { useItems } from '../hook/use-items'
import FormGroup from './form-group.vue'
import ItemRender from './item-render'

const props = defineProps({
  //表单数据
  model: Object,
  //表单定义
  formItems: {
    type: [Array, Object],
    default: null,
  },
  //获取表单定义接口
  formItemsUrl: {
    type: String,
    default: 'rest/ezcomp/dict/form/fetch/',
  },
  //表单定义code
  formItemsCode: {
    type: String,
    default: null,
  },
  //扩展参数
  extendCompileData: {
    type: Object,
    default: null,
  },
  //拖拽的class 如.pg-form-item-label__drag
  dragHandle: String,
  dataType: String,
  dragUpdateMethod: Function,
  dragRemoveMethod: Function,
})
const emit = defineEmits(['on-form-items-update'])

const formData = toRef(props, 'model')
const compileSource = computed(() => ({ data: props.model, ...props.extendCompileData }))

const { formItemsList, formProperty, formItemWidth } = useItems({
  formItems: toRef(props, 'formItems'),
  formItemsUrl: toRef(props, 'formItemsUrl'),
  formItemsCode: toRef(props, 'formItemsCode'),
  compileSource,
})

const show = ref(true)
watch(formItemsList, (newVal, oldVal) => {
  if (oldVal?.length > 0) {
    show.value = false
    nextTick(() => {
      show.value = true
    })
  }
  emit('on-form-items-update', formItemsList.value)
})

const formRef = ref(null)
const validate = async () => {
  const errorMap = await formRef.value.validate()?.catch((err) => err)
  if (errorMap !== true) {
    return errorMap
  }
}

let sortableInstance = null
const creatSortable = (dom) => {
  sortableInstance = Sortable.create(dom, {
    group: {
      name: 'portal',
      pull: true,
    },
    handle: props.dragHandle,
    animation: 120,
    // ghostClass: '',
    // fallbackClass: '',
    dragClass: 'pg-form__item-drag',
    onRemove(event) {
      props.dragRemoveMethod(
        {
          fromItemField: event.item.getAttribute('data-type'),
          //如果新的index是去到的列表最后一个，则表示需要将拖拽的元素push到目标列表中
          toItemField:
            event.newIndex + 1 === event.to.children.length
              ? event.to.children[event.newIndex - 1].getAttribute('data-type')
              : event.to.children[event.newIndex + 1].getAttribute('data-type'),
          from: event.from.getAttribute('data-type'),
          to: event.to.getAttribute('data-type'),
        },
        event
      )
    },
    onUpdate(event) {
      props.dragUpdateMethod?.(
        {
          fromItemField: event.item.getAttribute('data-type'),
          toItemField:
            event.newIndex > event.oldIndex
              ? event.to.children[event.newIndex - 1].getAttribute('data-type')
              : event.to.children[event.newIndex + 1].getAttribute('data-type'),
          from: event.from.getAttribute('data-type'),
          to: event.to.getAttribute('data-type'),
        },
        event
      )
    },
    // onStart(event) {
    //   // vm.droping = true
    // },
    // onEnd(event) {
    //   // vm.droping = false
    // },
  })
}
onMounted(() => {
  if (props.dragHandle) {
    creatSortable(formRef.value.$el)
  }
})
onUnmounted(() => {
  if (sortableInstance) {
    sortableInstance.destroy()
  }
})

defineExpose({
  validate,
})
</script>
<style lang="scss">
@import '../style/form-main.scss';
</style>
